import * as React from 'react';

export const PrivacyPolicy = () => {
    return (
        <div className="sid-privacy-policy sid-footer-privacy-policy sid-footer">
            <a href="https://www.sheerid.com/privacy-policy/" target="noopener noreferrer">SheerID Privacy Policy</a>
        </div>
    );
};
